import Vue from 'vue';

import Render from './Render';
import * as integrationVariants from './integrations/variants';
// import { IntegrationStyles } from './types';

declare global {
    interface Window {
        AdyenCheckout: any;
        Stripe: any;
        paysafe: any;
        StripeInited: any;
        CustomEvent: any;
        Event: any;
    }
}

class PaymentGateway {
    // @ts-ignore
    public currentIntegration: string;
    public mountingPreInitHelper: any = {};
    public reInit: any;
    public Vue: any = Vue;
    private Component: any;

    constructor(integrationSettings: any, reInitFunction?, preInitFunction?) {
        this.installPolyfills();
        const initIntegration = (integration) => {
            const self = this;
            this.currentIntegration = integration.name;
            this.Component = Render.extend({
                methods: {
                    install() {
                        // @ts-ignore
                        this.Integration = new (integrationVariants as any)[integration.name](
                            this,
                            {
                                ...integration,
                            },
                        );
                    },
                    // TODO-bozhyk refactor thi reiniting stuffs. Caused by hot fix CBAPI-3347
                    // We can awoid reInit() logic if we will provide right preInit whic will just switch everything to
                    // right gateway. No time to fix and test that now.
                    async preInit() {
                        if (preInitFunction) {
                            const anotherIntegration = await preInitFunction(self.mountingPreInitHelper);
                            if (anotherIntegration) {
                                self.currentIntegration = anotherIntegration;
                                // @ts-ignore
                                this.Integration = new (integrationVariants as any)[anotherIntegration.name](
                                    this,
                                    {
                                        ...anotherIntegration,
                                    },
                                );
                            }
                        }
                    },
                },
            });
        };

        this.reInit = (options = {}) => {
            initIntegration(reInitFunction(options));
        };

        initIntegration(integrationSettings);
    }

    public install(VueInstance) {
        this.Vue = VueInstance;
        this.Vue.component('payment-gateway', this.Component);
    }

    public legacyMount(selector: string, mountingPreInitHelper: any) {
        this.mountingPreInitHelper = mountingPreInitHelper || {};
        const self = this;
        const DomElement = document.getElementById(selector.replace('#', ''));
        if (!DomElement) {
            // tslint:disable-next-line
            console.error('Undefined selector');
            return false;
        }
        const ComponentDom = DomElement.getElementsByTagName('payment-gateway')[0];
        ComponentDom.setAttribute('ref', 'gateway');
        this.Vue.component('payment-gateway', this.Component);
        return new this.Vue({
            // @ts-ignore
            render: this.Vue.compile(DomElement.outerHTML).render,
        }).$mount(selector).$refs.gateway;
    }

    private installPolyfills() {
        // IE9 - IE11 dispatchEvent

        (() => {
            if ( typeof window.CustomEvent === 'function' ) { // If not IE
                return false;
            }

            function CustomEvent( event, params ) {
                params = params || { bubbles: false, cancelable: false, detail: undefined };
                const evt = document.createEvent( 'CustomEvent' );
                evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
                return evt;
            }

            CustomEvent.prototype = window.Event.prototype;

            window.CustomEvent = CustomEvent;
        })();

        // **
    }
}

export default PaymentGateway;
